/* eslint-disable max-lines */
import { Avatar } from '@george-labs.com/design-system';
import type { ICON } from '@george-labs.com/george-assets/icons';

import { MainCategoryName, SubCategoryName } from '@shared/categories-utils';

export const iconsByCategory: Record<MainCategoryName, ICON> = {
    [MainCategoryName.LIVING_AND_ENERGY]: Avatar.ICON.PFM_LIVING,
    [MainCategoryName.FOOD]: Avatar.ICON.PFM_FOOD,
    [MainCategoryName.HEALTH]: Avatar.ICON.PFM_HEALTH,
    [MainCategoryName.CLOTHING]: Avatar.ICON.PFM_CLOTHING,
    [MainCategoryName.COMMUNICATION]: Avatar.ICON.PFM_MEDIA,
    [MainCategoryName.LEISURE]: Avatar.ICON.PFM_HOBBY,
    [MainCategoryName.EDUCATION]: Avatar.ICON.PFM_EDUCATION,
    [MainCategoryName.CAR]: Avatar.ICON.PFM_CAR,
    [MainCategoryName.TRANSPORT]: Avatar.ICON.PFM_PUBLIC_TRANSPORT,
    [MainCategoryName.TRAVEL_HOLIDAYS]: Avatar.ICON.PFM_HOLIDAYS,
    [MainCategoryName.WITHDRAWAL]: Avatar.ICON.PFM_WITHDRAWAL,
    [MainCategoryName.ALIMONY_POCKET_MONEY]: Avatar.ICON.PFM_ALIMONY,
    [MainCategoryName.ONLINE_SHOPPING]: Avatar.ICON.PFM_ONLINE,
    [MainCategoryName.SAVINGS_INVESTMENT]: Avatar.ICON.SAVINGS,
    [MainCategoryName.TAXES]: Avatar.ICON.PFM_TAXES,
    [MainCategoryName.FEES]: Avatar.ICON.PFM_FEES,
    [MainCategoryName.OTHER_EXPENSES]: Avatar.ICON.PFM_ADDITIONAL_OUTGOING,
    [MainCategoryName.UNCATEGORIZED_EXPENSE]: Avatar.ICON.PFM_OTHER_OUTGOING,
    [MainCategoryName.REGULAR_INCOME]: Avatar.ICON.PFM_OTHER_INCOMING,
    [MainCategoryName.NON_REGULAR_INCOME]: Avatar.ICON.PFM_ADDITIONAL_INCOMING,
    [MainCategoryName.UNCATEGORIZED_INCOME]: Avatar.ICON.PFM_OTHER_INCOMING,
};

export const iconsBySubCategory: Record<SubCategoryName, ICON> = {
    [SubCategoryName.OTHER_LIVING_AND_ENERGY]: Avatar.ICON.PFM_LIVING,
    [SubCategoryName.OTHER_FOOD]: Avatar.ICON.PFM_FOOD,
    [SubCategoryName.HOLIDAY_FOOD_DRINKS]: Avatar.ICON.PFM_FOOD,
    [SubCategoryName.OTHER_HEALTH]: Avatar.ICON.PFM_HEALTH,
    [SubCategoryName.OTHER_CLOTHING]: Avatar.ICON.PFM_CLOTHING,
    [SubCategoryName.OTHER_LEISURE]: Avatar.ICON.PFM_LEISURE,
    [SubCategoryName.OTHER_EDUCATION]: Avatar.ICON.PFM_EDUCATION,
    [SubCategoryName.SECURITIES]: Avatar.ICON.PFM_EDUCATION,
    [SubCategoryName.OTHER_CAR]: Avatar.ICON.PFM_CAR,
    [SubCategoryName.PUBLIC_TRANSPORT]: Avatar.ICON.PFM_PUBLIC_TRANSPORT,
    [SubCategoryName.OTHER_HOLIDAY]: Avatar.ICON.PFM_HOLIDAYS,
    [SubCategoryName.ATM_WITHDRAWAL]: Avatar.ICON.PFM_WITHDRAWAL,
    [SubCategoryName.CASH_DEPOSIT]: Avatar.ICON.PFM_WITHDRAWAL,
    [SubCategoryName.OTHER_ALIMONY_POCKET_MONEY]: Avatar.ICON.PFM_ALIMONY,
    [SubCategoryName.MATERNITY_LEAVE]: Avatar.ICON.PFM_ALIMONY,
    [SubCategoryName.TUITION]: Avatar.ICON.PFM_TAXES,
    [SubCategoryName.OTHER_TAXES]: Avatar.ICON.PFM_TAXES,
    [SubCategoryName.OTHER_FEES]: Avatar.ICON.PFM_FEES,
    [SubCategoryName.OTHER_REGULAR_INCOME]: Avatar.ICON.PFM_OTHER_INCOMING,
    [SubCategoryName.FOOD_SHOPPING]: Avatar.ICON.SHOPPING,
    [SubCategoryName.UNCATEGORIZED_ONLINE_SHOPPING]: Avatar.ICON.SHOPPING,
    [SubCategoryName.SALARY]: Avatar.ICON.CALENDAR,
    [SubCategoryName.SAVINGS]: Avatar.ICON.SAVINGS,
    [SubCategoryName.OTHER_SAVINGS]: Avatar.ICON.SAVINGS,
    [SubCategoryName.SAVINGS_INCOME]: Avatar.ICON.SAVINGS,
    [SubCategoryName.INTERNET]: Avatar.ICON.WORLD,
    [SubCategoryName.WEB_SERVICES]: Avatar.ICON.WORLD,
    [SubCategoryName.CASH_WITHDRAWAL]: Avatar.ICON.MONEY,
    [SubCategoryName.EXTERNAL_TRANSFERS]: Avatar.ICON.PFM_OTHER_OUTGOING,
    [SubCategoryName.RENT]: Avatar.ICON.BUSINESS,
    [SubCategoryName.BUSINESS_INCOME]: Avatar.ICON.BUSINESS,
    [SubCategoryName.RENTAL]: Avatar.ICON.BUSINESS,
    [SubCategoryName.HOUSE_LOAN]: Avatar.ICON.BUILDING_SOCIETY_LOAN,
    [SubCategoryName.ENERGY]: Avatar.ICON.FLASH,
    [SubCategoryName.UTILITY_BILLS]: Avatar.ICON.INVOICE_POSTAL,
    [SubCategoryName.CREDIT_CARD_BILL]: Avatar.ICON.INVOICE,
    [SubCategoryName.WASTE_DISPOSAL]: Avatar.ICON.PFM_WASTE,
    [SubCategoryName.SEWER_FEES]: Avatar.ICON.PFM_SEWER,
    [SubCategoryName.INSURANCE]: Avatar.ICON.INSURANCE,
    [SubCategoryName.INSURANCE_PREMIUM]: Avatar.ICON.INSURANCE,
    [SubCategoryName.UNKNOWN_INSURANCE]: Avatar.ICON.INSURANCE,
    [SubCategoryName.INSURANCE_INCOME]: Avatar.ICON.INSURANCE,
    [SubCategoryName.IMPROVEMENTS_AND_FURNITURE]: Avatar.ICON.PENSION_SAVINGS,
    [SubCategoryName.FURNITURE]: Avatar.ICON.PENSION_SAVINGS,
    [SubCategoryName.PENSION]: Avatar.ICON.MONEY,
    [SubCategoryName.PENSION_INVESTMENT]: Avatar.ICON.COINS_SAVINGS,
    [SubCategoryName.CLEANING]: Avatar.ICON.PFM_CLEANING,
    [SubCategoryName.PET_CARE]: Avatar.ICON.PFM_PET,
    [SubCategoryName.PROPERTY_INSURANCE]: Avatar.ICON.PROPERTY_INSURANCE,
    [SubCategoryName.PIP_INSURANCE]: Avatar.ICON.LIABILITY_INSURANCE,
    [SubCategoryName.RESTAURANT]: Avatar.ICON.PFM_CAFE,
    [SubCategoryName.DRUGSTORE]: Avatar.ICON.PFM_DRUGSTORE,
    [SubCategoryName.PHARMACY]: Avatar.ICON.PFM_PHARMACY,
    [SubCategoryName.COSMETICS]: Avatar.ICON.SHOW_ON,
    [SubCategoryName.DOCTORS_HOSPITAL]: Avatar.ICON.PFM_DOCTOR,
    [SubCategoryName.LIFE_HEALTH_INSURANCE]: Avatar.ICON.LIFE_HEALTH_INSURANCE,
    [SubCategoryName.LIFE_INSURANCE]: Avatar.ICON.LIFE_INSURANCE,
    [SubCategoryName.ACCIDENT_INSURANCE]: Avatar.ICON.ACCIDENT_INSURANCE,
    [SubCategoryName.COSMETICS_AND_APPEARANCE]: Avatar.ICON.PFM_COSMETICS,
    [SubCategoryName.HEALTH_INSURANCE]: Avatar.ICON.HEALTH_INSURANCE,
    [SubCategoryName.RISK_LIFE_INSURANCE]: Avatar.ICON.RISK_LIFE_INSURANCE,
    [SubCategoryName.FASHION]: Avatar.ICON.PFM_FASHION,
    [SubCategoryName.SHOES]: Avatar.ICON.PFM_SHOES,
    [SubCategoryName.ACCESSORIES]: Avatar.ICON.PFM_ACCESSORIES,
    [SubCategoryName.PHONE_BILLS]: Avatar.ICON.PHONE_HOTLINE,
    [SubCategoryName.TELEVISION]: Avatar.ICON.COMPUTER_2,
    [SubCategoryName.ENTERTAINMENT_ELECTRONICS]: Avatar.ICON.PFM_ELECTRONICS,
    [SubCategoryName.AMUSEMENT]: Avatar.ICON.PFM_AMUSEMENT,
    [SubCategoryName.HOBBIES_SPORT]: Avatar.ICON.PFM_SPORT,
    [SubCategoryName.READING]: Avatar.ICON.PFM_BOOKS,
    [SubCategoryName.BOOKS_SUPPLIES]: Avatar.ICON.PFM_BOOKS,
    [SubCategoryName.TOYS_GAMES]: Avatar.ICON.PFM_GAMES,
    [SubCategoryName.TOBACCONIST]: Avatar.ICON.PFM_TABACCO,
    [SubCategoryName.BETTING]: Avatar.ICON.PFM_BETTING,
    [SubCategoryName.HOBBIES_COTTAGE_GARDEN]: Avatar.ICON.LEAF,
    [SubCategoryName.KINDERGARTEN_SCHOOL_UNIVERSITY]: Avatar.ICON.PFM_SCHOOL,
    [SubCategoryName.CAR_PURCHASE_LOAN]: Avatar.ICON.HAND_COINS,
    [SubCategoryName.LENDING]: Avatar.ICON.HAND_COINS,
    [SubCategoryName.FINANCING]: Avatar.ICON.HAND_COINS,
    [SubCategoryName.GAS_FUEL]: Avatar.ICON.PFM_FUEL,
    [SubCategoryName.CAR_MAINTENANCE]: Avatar.ICON.PFM_SERVICE,
    [SubCategoryName.CAR_INSURANCE]: Avatar.ICON.CAR_INSURANCE,
    [SubCategoryName.PARKING]: Avatar.ICON.PFM_PARKING,
    [SubCategoryName.TOLLS]: Avatar.ICON.PFM_TOLLS,
    [SubCategoryName.TAXI]: Avatar.ICON.PFM_TAXI,
    [SubCategoryName.OTHER_TRANSPORT]: Avatar.ICON.PFM_OTHER_TRANSPORT,
    [SubCategoryName.HOLIDAY_ACCOMODATION]: Avatar.ICON.PFM_ACCOMODATION,
    [SubCategoryName.HOLIDAY_EXPENSES]: Avatar.ICON.PFM_TRAVEL_EXPENSES,
    [SubCategoryName.FOREIGN_CURRENCY]: Avatar.ICON.FOREIGN_CURRENCY_ACCOUNT,
    [SubCategoryName.TRAVEL_INSURANCE]: Avatar.ICON.TRAVEL_INSURANCE,
    [SubCategoryName.BRANCH_WITHDRAWAL]: Avatar.ICON.BANK,
    [SubCategoryName.BANK_INFO]: Avatar.ICON.BANK,
    [SubCategoryName.CREDIT_CARD_WITHDRAWAL]: Avatar.ICON.CARD_CREDITCARD,
    [SubCategoryName.QUICK_CHARGING]: Avatar.ICON.MOBILE_TOP_UP,
    [SubCategoryName.OTHER_WITHDRAWAL]: Avatar.ICON.PFM_CASH,
    [SubCategoryName.ALIMONEY]: Avatar.ICON.PFM_ALIMONY_LEGAL,
    [SubCategoryName.ALIMONY]: Avatar.ICON.PFM_ALIMONY_LEGAL,
    [SubCategoryName.POCKET_MONEY]: Avatar.ICON.PFM_POCKETMONEY,
    [SubCategoryName.PRIVATE_CONTRIBUTION]: Avatar.ICON.PLUGIN_GIFTCARD,
    [SubCategoryName.GIFTS]: Avatar.ICON.PLUGIN_GIFTCARD,
    [SubCategoryName.AMAZON]: Avatar.ICON.PFM_AMAZON,
    [SubCategoryName.GOOGLE]: Avatar.ICON.PFM_GOOGLE,
    [SubCategoryName.ONLINE_SHOPS]: Avatar.ICON.PFM_ONLINE,
    [SubCategoryName.ONLINE_SHOP]: Avatar.ICON.PFM_ONLINE,
    [SubCategoryName.BUILDING_SOCIETY]: Avatar.ICON.BUILDING_SAVINGS,
    [SubCategoryName.CAPITALIZATION_PRODUCTS]: Avatar.ICON.PFM_CAPITALISATION,
    [SubCategoryName.CRYPTOCURRENCY]: Avatar.ICON.PFM_CRYPTO,
    [SubCategoryName.CRYPTO_INCOME]: Avatar.ICON.PFM_CRYPTO,
    [SubCategoryName.INVESTMENTPLAN]: Avatar.ICON.PORTFOLIO,
    [SubCategoryName.INVESTMENT_INCOME]: Avatar.ICON.PORTFOLIO,
    [SubCategoryName.NOBLE_METAL]: Avatar.ICON.GOLD_BARS,
    [SubCategoryName.PERSONAL_INCOME_TAX]: Avatar.ICON.BRIEFCASE,
    [SubCategoryName.UNEMPLOYMENT_COMPENSATION]: Avatar.ICON.BRIEFCASE,
    [SubCategoryName.VALUE_ADDED_TAX]: Avatar.ICON.TAG,
    [SubCategoryName.INTERESTS]: Avatar.ICON.PFM_INTEREST,
    [SubCategoryName.SAVINGS_INVESTMENT_INCOME]: Avatar.ICON.PFM_INTEREST,
    [SubCategoryName.INTERNAL_TRANSFERS]: Avatar.ICON.ARROW_UP_DOWN,
    [SubCategoryName.INTERNAL_TRANSFER]: Avatar.ICON.ARROW_UP_DOWN,
    [SubCategoryName.SOCIAL_INSURANCE]: Avatar.ICON.SOCIAL_INSURANCE,
    [SubCategoryName.DONATIONS]: Avatar.ICON.CHARITY,
    [SubCategoryName.DONATIONS_ASSOCIATION]: Avatar.ICON.CHARITY,
    [SubCategoryName.PENALTIES_GOVERNMENTS]: Avatar.ICON.LIABILITY,
    [SubCategoryName.COLLECTION]: Avatar.ICON.PFM_DEBT_COLLECTION,
    [SubCategoryName.LIABILITY_INSURANCE]: Avatar.ICON.CASUALTY_INSURANCE,
    [SubCategoryName.PAYMENT_PROTECTION_INSURANCE]: Avatar.ICON.PAYMENT_PROTECTION_INSURANCE,
    [SubCategoryName.INCOME_PROTECTION_INSURANCE]: Avatar.ICON.INCOME_PROTECTION_INSURANCE,
    [SubCategoryName.OTHER_FINANCING]: Avatar.ICON.HAND_COIN,
    [SubCategoryName.FAMILY_ALLOWANCE]: Avatar.ICON.GROUP,
    [SubCategoryName.OVERTIME_TRAVEL_COMPENSATION]: Avatar.ICON.AIRPLANE,
    [SubCategoryName.REIMBURSEMENT]: Avatar.ICON.REPLY,
    [SubCategoryName.OTHER_NON_REGULAR_INCOME]: Avatar.ICON.PFM_ADDITIONAL_INCOMING,
    [SubCategoryName.EXTERNAL_TRANSFERS_INCOMING]: Avatar.ICON.PFM_OTHER_INCOMING,
    [SubCategoryName.PENSION_INSURANCE]: Avatar.ICON.INSURANCE,
    [SubCategoryName.FEES]: Avatar.ICON.PFM_FEES,
    [SubCategoryName.UNCATEGORIZED_EXPENSE]: Avatar.ICON.PFM_OTHER_OUTGOING,
    [SubCategoryName.UNCATEGORIZED_INCOME]: Avatar.ICON.PFM_OTHER_INCOMING,
    [SubCategoryName.TAXES]: Avatar.ICON.PFM_TAXES,
    [SubCategoryName.LEGAL_INSURANCE]: Avatar.ICON.LIABILITY,
    [SubCategoryName.PET_INSURANCE]: Avatar.ICON.PET_INSURANCE,
    [SubCategoryName.DISABILITY_INSURANCE]: Avatar.ICON.ACCIDENT_INSURANCE,
    [SubCategoryName.CYBER_INSURANCE]: Avatar.ICON.COMPUTER_SECURITY,
};

export const iconsByName: Record<`icon:ico-${string}`, ICON> = {
    'icon:ico-pfm-living': Avatar.ICON.PFM_LIVING,
    'icon:ico-pfm-food': Avatar.ICON.PFM_FOOD,
    'icon:ico-pfm-health': Avatar.ICON.PFM_HEALTH,
    'icon:ico-pfm-clothing': Avatar.ICON.PFM_CLOTHING,
    'icon:ico-pfm-communication': Avatar.ICON.PFM_MEDIA,
    'icon:ico-pfm-media': Avatar.ICON.PFM_MEDIA,
    'icon:ico-pfm-leisure': Avatar.ICON.PFM_HOBBY,
    'icon:ico-pfm-hobby': Avatar.ICON.PFM_HOBBY,
    'icon:ico-pfm-education': Avatar.ICON.PFM_EDUCATION,
    'icon:ico-pfm-car': Avatar.ICON.PFM_CAR,
    'icon:ico-pfm-public-transport': Avatar.ICON.PFM_PUBLIC_TRANSPORT,
    'icon:ico-pfm-holiday': Avatar.ICON.PFM_HOLIDAYS,
    'icon:ico-pfm-holidays': Avatar.ICON.PFM_HOLIDAYS,
    'icon:ico-pfm-withdrawal': Avatar.ICON.PFM_WITHDRAWAL,
    'icon:ico-pfm-atm': Avatar.ICON.PFM_WITHDRAWAL,
    'icon:ico-pfm-alimoney': Avatar.ICON.PFM_ALIMONY,
    'icon:ico-pfm-online-shops': Avatar.ICON.PFM_ONLINE,
    'icon:ico-pfm-pfm-online': Avatar.ICON.PFM_ONLINE,
    'icon:ico-pfm-savings': Avatar.ICON.SAVINGS,
    'icon:ico-pfm-taxes': Avatar.ICON.PFM_TAXES,
    'icon:ico-pfm-fees': Avatar.ICON.PFM_FEES,
    'icon:ico-pfm-other-expenses': Avatar.ICON.PFM_OTHER_OUTGOING,
    'icon:ico-pfm-additional-expenses': Avatar.ICON.PFM_ADDITIONAL_OUTGOING,
    'icon:ico-pfm-uncategorized-expenses': Avatar.ICON.PFM_UNCATEGORISED_OUTGOING,
    'icon:ico-pfm-regular-income': Avatar.ICON.PFM_OTHER_INCOMING,
    'icon:ico-pfm-other-incoming': Avatar.ICON.PFM_OTHER_INCOMING,
    'icon:ico-pfm-non-regular-income': Avatar.ICON.PFM_OTHER_INCOMING,
    'icon:ico-pfm-uncategorized-income': Avatar.ICON.PFM_UNCATEGORISED_INCOMING,
    'icon:ico-shopping': Avatar.ICON.SHOPPING,
    'icon:ico-card': Avatar.ICON.BANKCARD,
    'icon:ico-bankcard': Avatar.ICON.BANKCARD,
    'icon:ico-cards': Avatar.ICON.CARD_ADDITIONAL,
    'icon:ico-card-additional': Avatar.ICON.CARD_ADDITIONAL,
    'icon:ico-calendar': Avatar.ICON.CALENDAR,
    'icon:ico-direct-debit-sipo': Avatar.ICON.DIRECT_DEBIT_SIPO,
    'icon:ico-direct-debit-2': Avatar.ICON.DIRECT_DEBIT_OUTGOING,
    'icon:ico-direct-debit-outgoing': Avatar.ICON.DIRECT_DEBIT_OUTGOING,
    'icon:ico-info-circle': Avatar.ICON.INFO,
    'icon:ico-info': Avatar.ICON.INFO,
    'icon:ico-repeat': Avatar.ICON.STANDING_ORDER,
    'icon:ico-standing-order': Avatar.ICON.STANDING_ORDER,
    'icon:ico-round-saving': Avatar.ICON.SAVINGS,
    'icon:ico-money-coins': Avatar.ICON.MONEY,
    'icon:ico-savings': Avatar.ICON.SAVINGS,
    'icon:ico-atm': Avatar.ICON.PFM_WITHDRAWAL,
    'icon:ico-transfer-international': Avatar.ICON.MONEY,
    'icon:ico-world': Avatar.ICON.WORLD,
    'icon:ico-mobile-phone': Avatar.ICON.PHONE_MOBILE,
    'icon:ico-phone-mobile': Avatar.ICON.PHONE_MOBILE,
    'icon:ico-sipo': Avatar.ICON.DIRECT_DEBIT_SIPO,
    'icon:ico-savings-coin': Avatar.ICON.SAVINGS,
    'icon:ico-error': Avatar.ICON.ERROR,
    'icon:ico-file-transfer': Avatar.ICON.PLUGIN_FILETRANSFER,
    'icon:ico-plugin-filetransfer': Avatar.ICON.PLUGIN_FILETRANSFER,
    'icon:ico-money': Avatar.ICON.MONEY,
    'icon:ico-money-up': Avatar.ICON.MONEY,
    'icon:ico-money-out': Avatar.ICON.PFM_OTHER_OUTGOING,
    'icon:ico-pfm-other-outgoing': Avatar.ICON.PFM_OTHER_OUTGOING,
    'icon:ico-money-in': Avatar.ICON.PFM_OTHER_INCOMING,
    'icon:ico-hilfreich': Avatar.ICON.HILFREICH,
    'icon:ico-business': Avatar.ICON.BUSINESS,
    'icon:ico-building-society-loan': Avatar.ICON.BUILDING_SOCIETY_LOAN,
    'icon:ico-flash': Avatar.ICON.FLASH,
    'icon:ico-invoice': Avatar.ICON.INVOICE_POSTAL,
    'icon:ico-pfm-waste': Avatar.ICON.PFM_WASTE,
    'icon:ico-pfm-sewer': Avatar.ICON.PFM_SEWER,
    'icon:ico-insurance': Avatar.ICON.INSURANCE,
    'icon:ico-pension': Avatar.ICON.MONEY,
    'icon:ico-pension-savings': Avatar.ICON.COINS_SAVINGS,
    'icon:ico-pfm-cleaning': Avatar.ICON.PFM_CLEANING,
    'icon:ico-pfm-pet': Avatar.ICON.PFM_PET,
    'icon:ico-property-insurance': Avatar.ICON.PROPERTY_INSURANCE,
    'icon:ico-liability-insurance': Avatar.ICON.LIABILITY_INSURANCE,
    'icon:ico-pfm-cafe': Avatar.ICON.PFM_CAFE,
    'icon:ico-pfm-drugstore': Avatar.ICON.PFM_DRUGSTORE,
    'icon:ico-pfm-pharmacy': Avatar.ICON.PFM_PHARMACY,
    'icon:ico-show-on': Avatar.ICON.SHOW_ON,
    'icon:ico-pfm-doctor': Avatar.ICON.PFM_DOCTOR,
    'icon:ico-life-health-insurance': Avatar.ICON.LIFE_HEALTH_INSURANCE,
    'icon:ico-life-insurance': Avatar.ICON.LIFE_INSURANCE,
    'icon:ico-accident-insurance': Avatar.ICON.ACCIDENT_INSURANCE,
    'icon:ico-pfm-cosmetics': Avatar.ICON.PFM_COSMETICS,
    'icon:ico-health-insurance': Avatar.ICON.HEALTH_INSURANCE,
    'icon:ico-risk-life-insurance': Avatar.ICON.RISK_LIFE_INSURANCE,
    'icon:ico-pfm-fashion': Avatar.ICON.PFM_FASHION,
    'icon:ico-pfm-shoes': Avatar.ICON.PFM_SHOES,
    'icon:ico-pfm-accessories': Avatar.ICON.PFM_ACCESSORIES,
    'icon:ico-phone-hotline': Avatar.ICON.PHONE_HOTLINE,
    'icon:ico-computer-2': Avatar.ICON.COMPUTER_2,
    'icon:ico-pfm-electronics': Avatar.ICON.PFM_ELECTRONICS,
    'icon:ico-pfm-amusement': Avatar.ICON.PFM_AMUSEMENT,
    'icon:ico-pfm-sport': Avatar.ICON.PFM_SPORT,
    'icon:ico-pfm-books': Avatar.ICON.PFM_BOOKS,
    'icon:ico-pfm-games': Avatar.ICON.PFM_GAMES,
    'icon:ico-pfm-tabacco': Avatar.ICON.PFM_TABACCO,
    'icon:ico-pfm-betting': Avatar.ICON.PFM_BETTING,
    'icon:ico-leaf': Avatar.ICON.LEAF,
    'icon:ico-pfm-school': Avatar.ICON.PFM_SCHOOL,
    'icon:ico-hand-coins': Avatar.ICON.HAND_COINS,
    'icon:ico-pfm-fuel': Avatar.ICON.PFM_FUEL,
    'icon:ico-pfm-service': Avatar.ICON.PFM_SERVICE,
    'icon:ico-car-insurance': Avatar.ICON.CAR_INSURANCE,
    'icon:ico-pfm-parking': Avatar.ICON.PFM_PARKING,
    'icon:ico-pfm-tolls': Avatar.ICON.PFM_TOLLS,
    'icon:ico-pfm-taxi': Avatar.ICON.PFM_TAXI,
    'icon:ico-pfm-other-transport': Avatar.ICON.PFM_OTHER_TRANSPORT,
    'icon:ico-pfm-accomodation': Avatar.ICON.PFM_ACCOMODATION,
    'icon:ico-pfm-travel-expenses': Avatar.ICON.PFM_TRAVEL_EXPENSES,
    'icon:ico-foreign-currency-account': Avatar.ICON.FOREIGN_CURRENCY_ACCOUNT,
    'icon:ico-travel-insurance': Avatar.ICON.TRAVEL_INSURANCE,
    'icon:ico-bank': Avatar.ICON.BANK,
    'icon:ico-card-creditcard': Avatar.ICON.CARD_CREDITCARD,
    'icon:ico-mobile-top-up': Avatar.ICON.MOBILE_TOP_UP,
    'icon:ico-pfm-cash': Avatar.ICON.PFM_CASH,
    'icon:ico-pfm-alimoney-legal': Avatar.ICON.PFM_ALIMONY_LEGAL,
    'icon:ico-pfm-pocketmoney': Avatar.ICON.PFM_POCKETMONEY,
    'icon:ico-plugin-giftcard': Avatar.ICON.PLUGIN_GIFTCARD,
    'icon:ico-pfm-amazon': Avatar.ICON.PFM_AMAZON,
    'icon:ico-pfm-google': Avatar.ICON.PFM_GOOGLE,
    'icon:ico-pfm-online': Avatar.ICON.PFM_ONLINE,
    'icon:ico-building-savings': Avatar.ICON.BUILDING_SAVINGS,
    'icon:ico-pfm-capitalisation': Avatar.ICON.PFM_CAPITALISATION,
    'icon:ico-pfm-crypto': Avatar.ICON.PFM_CRYPTO,
    'icon:ico-portfolio': Avatar.ICON.PORTFOLIO,
    'icon:ico-gold-bars': Avatar.ICON.GOLD_BARS,
    'icon:ico-briefcase': Avatar.ICON.BRIEFCASE,
    'icon:ico-tag': Avatar.ICON.TAG,
    'icon:ico-pfm-interest': Avatar.ICON.PFM_INTEREST,
    'icon:ico-arrow-up-down': Avatar.ICON.ARROW_UP_DOWN,
    'icon:ico-social-insurance': Avatar.ICON.SOCIAL_INSURANCE,
    'icon:ico-charity': Avatar.ICON.CHARITY,
    'icon:ico-liability': Avatar.ICON.LIABILITY,
    'icon:ico-pfm-debt-collection': Avatar.ICON.PFM_DEBT_COLLECTION,
    'icon:ico-casualty-insurance': Avatar.ICON.CASUALTY_INSURANCE,
    'icon:ico-payment-protection-insurance': Avatar.ICON.PAYMENT_PROTECTION_INSURANCE,
    'icon:ico-income-protection-insurance': Avatar.ICON.INCOME_PROTECTION_INSURANCE,
    'icon:ico-hand-coin': Avatar.ICON.HAND_COIN,
    'icon:ico-group': Avatar.ICON.GROUP,
    'icon:ico-airplane': Avatar.ICON.AIRPLANE,
    'icon:ico-reply': Avatar.ICON.REPLY,
    'icon:ico-pfm-additional-incoming': Avatar.ICON.PFM_ADDITIONAL_INCOMING,
    'icon:ico-pension-insurance': Avatar.ICON.INSURANCE,
};
